module.exports = __webpack_public_path__ + "images/emoji/railway_car.25035642f12212c2af98.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/railway_car.png
// module id = Q3wr
// module chunks = 1